import React from 'react'
import Alert, { AlertProps } from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import MainTooltip from '../others/MainTooltip'

interface ErrorBoxProps extends AlertProps {
  errorMessage: string;
}

const ErrorBox: React.FC<ErrorBoxProps> = ({ errorMessage, onClose, title, ...rest }) => {
  return (
    <Alert
      data-testid="error-box"
      severity="error"
      sx={{ alignItems: 'center' }}
      onClose={onClose}
      action={
        onClose && (
          <MainTooltip title="Fechar">
            <IconButton onClick={onClose} data-testid="error-box-close-button">
              <CloseIcon fontSize="medium" />
            </IconButton>
          </MainTooltip>
        )
      }
      {...rest}
    >
      {title && <AlertTitle>{title}</AlertTitle>}
      {errorMessage}
    </Alert>
  )
}

export default ErrorBox
